var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48633 26.7293V18.455L8.72519 15.3533L15.964 18.4573V26.7293L8.72519 29.8287L1.48633 26.7293Z",
    stroke: "#FFB85C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48633 18.4388L8.72518 21.5406L15.964 18.4388M8.72518 7.13599L15.9618 10.24L23.2006 7.13827",
    stroke: "#FFB85C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9619 18.4387L23.2008 21.5404L30.4396 18.4387",
    stroke: "#FFB85C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72461 21.5452V29.8309M23.2046 21.5452V29.8309M15.9612 10.2401V18.5235M8.72918 15.3487V7.07437L15.9658 3.97266L23.2046 7.07437V15.3487L15.9658 18.4504L8.72918 15.3487ZM15.9612 26.7292V18.4549L23.2 15.3532L30.4389 18.4572V26.7292L23.2 29.8287L15.9612 26.7292Z",
    stroke: "#FFB85C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.219ea377732170d1c283ca4886b2b3b8.svg";
export { ForwardRef as ReactComponent };